module.exports = __webpack_public_path__ + "media/images/countrysquared/jm-2370e774de7c3096992997e99059138a.svg";